import { RequestStatus } from 'components/GeneralFormView/types';
import { WheelEventsGroup } from 'mobx-store/storeInterfaces/wheelFortuneInterface';
import {
  WheelFortuneStore,
} from 'mobx-store/stores/wheelFortuneStore';

interface WheelProps {
  wheelFortuneStore: WheelFortuneStore;
}
export type PrizesProps = WheelProps;

export type EventWinnersProps = WheelProps;

export type EventsProps = WheelProps;

export enum State {
  LOADING = 'LOADING',
  DONE = 'DONE',
  FAILED = 'FAILED',
  IDEAL = 'IDEAL'
}

export const ColorPlette: {[key: string]: string} = {
  mid_blue: '#52AADC',
  yellow: '#F4D258',
  green: '#C8F151',
  light_blue: '#52E4C1',
  gold: '#FFAB48',
  pink: '#D63971',
  purple: '#7F52DF',
};

export interface Pagintation {
  pageSize: number;
  pageNumber: number;
}

export interface AddEditEventsGroupsProps {
  wheelEventsGroup?: WheelEventsGroup;
  open: boolean;
  onClose: () => void;
  onSaveForm: (formValue: WheelEventsGroup) => void;
  loadingState: RequestStatus;
}